import cloudbase from '@cloudbase/js-sdk'

const env = import.meta.env.VITE_CLOUDBASE_ENV_ID
const region = import.meta.env.VITE_CLOUDBASE_REGION || 'ap-shanghai'
const accessKey = import.meta.env.VITE_CLOUDBASE_ACCESS_KEY

if (!env || !accessKey) {
  throw new Error('CloudBase 前端配置不完整')
}

export const cloudbaseApp = cloudbase.init({
  env,
  region,
  accessKey,
  auth: { detectSessionInUrl: true },
})

export const cloudbaseAuth = cloudbaseApp.auth

export async function hasSession(): Promise<boolean> {
  const { data, error } = await cloudbaseAuth.getSession()
  if (error) throw new Error(error.message || '读取登录会话失败')
  return Boolean(data?.session)
}

export async function signInWithPassword(username: string, password: string): Promise<void> {
  const { error } = await cloudbaseAuth.signInWithPassword({ username, password })
  if (error) throw new Error(error.message || '账号或密码不正确')
}

export async function signOut(): Promise<void> {
  await cloudbaseAuth.signOut()
}
